/**
 * A coordinator's request to correct a supported's Israeli ID (HAT-1428): the coordinator sees its
 * status on the supported, the office decides on it on its own «נתמכים» board.
 */
export interface SupportedIsraeliIdChangeRequestDtoIn {
  id: number;
  fundId: number;
  fundName: string | null;
  contactId: number;
  supportedName: string | null;
  /** The ID when the coordinator asked. */
  currentIsraeliId: string | null;
  requestedIsraeliId: string;
  note: string | null;
  status: SupportedIsraeliIdChangeRequestStatus;
  requestedByEmail: string | null;
  requestedByName: string | null;
  requestedAt: string;
  reviewedAt: string | null;
  /** Who decided - or, for a cancelled request, the coordinator who withdrew it. */
  reviewedByEmail: string | null;
  rejectionReason: string | null;
  /** When the coordinator saw the decision; null while it still shows on the supported. */
  acknowledgedAt: string | null;
}

/** Cancelled: withdrawn by the coordinator before the office decided. */
export type SupportedIsraeliIdChangeRequestStatus = 'Pending' | 'Approved' | 'Rejected' | 'Cancelled';

/** The office's answer to a decision: whether the mail to the coordinator went out, null when none was asked for. */
export interface IsraeliIdChangeRequestDecisionDtoIn {
  emailSent: boolean | null;
}

/** Gates the coordinator's link and endpoints; the office's queue is not behind it. */
export const SUPPORTED_ID_CHANGE_REQUESTS_FEATURE_KEY = 'supported-id-change-requests';

/**
 * The requests waiting for the office - shared by the «נתמכים» board and the sidebar badge, so a
 * decision clears both. With ?contactId=, one supported's requests in any status.
 */
export const ISRAELI_ID_CHANGE_REQUESTS_URL = 'management/israeli-id-change-requests';
